var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("b-container", { attrs: { fluid: "" } }, [
    _c(
      "div",
      { staticStyle: { "min-height": "650px" } },
      [
        _c(
          "b-button",
          {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.hover.top",
                value: "Close",
                expression: "'Close'",
                modifiers: { hover: true, top: true },
              },
            ],
            staticClass: "close btn-close btn-sm",
            attrs: { variant: "outline-primary" },
            on: {
              click: function ($event) {
                return _vm.onCloseReport()
              },
            },
          },
          [_c("i", { staticClass: "material-icons" }, [_vm._v("close")])]
        ),
        _c("iframe", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.isLoadingIframe,
              expression: "!isLoadingIframe",
            },
          ],
          staticStyle: { border: "0" },
          style: { height: _vm.inframeHeight + "px" },
          attrs: {
            frameborder: "0",
            allowfullscreen: "",
            width: "100%",
            src: _vm.url,
          },
          on: { load: _vm.loadIframe },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }